import React from 'react';
import { Modal } from 'react-bootstrap';
import { ViewIcon, Download2Icon } from 'assets/icons';
import { Constants, Globals } from 'utils';
import moment from 'moment';
import { Pagination, Input, DatePicker, Select, Button } from 'components';
import ModalViewAppointment from './modal-view-appoiment'
import { UsersService, AppoimentService, GeneralService } from 'services';

type IonChangeEvent = React.ChangeEvent<HTMLInputElement>;

const MODAL = {
  NONE: 0,
  VIEW: 1,
};


const INITIAL_STATE = {
  search: '',
  type: '',
  from: null,
  to: null
}


const getStatusColor = (status: number) => {
  switch (status) {
    case Constants.APPOINTMENT.STATUS.PENDING:
      return { className: 'pending', label: 'Pendiente' };
    case Constants.APPOINTMENT.STATUS.IN_PROCESS:
      return { className: 'in-process', label: 'En consulta' };
    case Constants.APPOINTMENT.STATUS.RESCHEDULED:
      return { className: 'rejected', label: 'Reagendado' };
    case Constants.APPOINTMENT.STATUS.FINISHED:
      return { className: 'finish', label: 'Culminada' };
    case Constants.APPOINTMENT.STATUS.CANCELLED:
      return { className: 'cancelled', label: 'Cancelado' };
    default:
      return { className: 'rejected', label: 'No definido' };
  }
}

class Appointments extends React.Component {

  debounce?: NodeJS.Timeout;

  state = {
    form: INITIAL_STATE,
    modal: MODAL.NONE,
    selectedItem: null,
    specialties: [],
    doctors: [],
    states: [],
    data: [],
    pagination: {
      pages: 1,
      page: 1,
    },
  }

  componentDidMount(): void {
    this.getSelects()
    this.load()
  }

  load = async (page: number = 1, download: boolean = false) => {
    try {
      const { from, to } = this.state.form;
      const _from = from ? moment(from).format('YYYY-MM-DD') : '';
      const _to = to ? moment(to).format('YYYY-MM-DD') : '';
      const res = await AppoimentService.get({ page, ...this.state.form, from: _from, to: _to, download })

      if (download) return res;

      const { data, ...rest } = res as any;
      this.setState({ data, pagination: rest });
    } catch (error) {
      const err = error as any;
      Globals.showError(err?.response?.data?.error ?? 'Ocurrió un error inesperado');
    }
  }

  download = async () => {
    try {
      const res: any = await this.load(this.state.pagination.page, true);
      if (!res?.url) return;

      const link = document.createElement('a');
      link.href = Globals.fromStorage(res?.url);
      link.download = 'reporte.xlsx';
      link.target = '_blank';
      link.click();

    } catch (error) {
      const err = error as any;
      Globals.showError(err?.response?.data?.error ?? 'Ocurrió un error inesperado');
    }
  }

  getSelects = async () => {
    const toSelect = (data: any) => data?.map((x: any) => ({ value: x.id, label: x.name })) ?? [];
    try {
      const specialities: any = await GeneralService.getSpecialties();
      const states = await GeneralService.getStates();
      const doctors: any = await UsersService.get({ per_page: 9999, level_id: Constants.LEVELS.DOCTOR });
      this.setState({
        specialties: toSelect(specialities),
        states: toSelect(states),
        doctors: doctors.data
      });
    } catch (error) {
      Globals.showError('Ocurrió un error inesperado');
    }
  }

  change = async (value: string | number | boolean, target: keyof typeof INITIAL_STATE) => {
    await this.setState((s: typeof this.state) => ({
      form: {
        ...s.form,
        [target]: value,
      }
    }));

    if (this.debounce) clearTimeout(this.debounce);
    this.debounce = setTimeout(async () => this.load(1), 800);
  }


  cleanFilters = async () => {
    await this.setState({ form: { ...INITIAL_STATE } });
    this.load(1);
  }

  setModal = async (modal: number, item?: any) => {
    this.setState({ modal, selectedItem: item ?? null });
  }

  render() {
    const { modal, form, selectedItem, specialties, doctors, states } = this.state
    const canCleanFilters = JSON.stringify(this.state.form) !== JSON.stringify(INITIAL_STATE);

    return (
      <div id="appointments">
        <Modal
          id="appoiment-view"
          size='lg'
          show={modal === MODAL.VIEW}
          onHide={() => this.setModal(MODAL.NONE)}
        >
          <ModalViewAppointment
            specialities={specialties}
            appointment={selectedItem}
            states={states}
            doctors={doctors}
            onClose={(reload) => {
              if (reload) this.load()
              this.setModal(MODAL.NONE)
            }}
          />
        </Modal>


        <section className="filters">
          <Input
            label="Buscar"
            className="search-input"
            placeholder="Nombre del paciente, medico"
            value={form.search}
            onChange={(e: IonChangeEvent) => this.change(e.target.value, 'search')}
          />

          <Select
            label="Tipo de consulta"
            name="type"
            className="select-filter"
            value={form.type}
            onChange={(e: IonChangeEvent) => this.change(e.target.value, 'type')}
            options={[
              { value: '1', label: 'Presencial' },
              { value: '2', label: 'Online' },
            ]}
          />

          <DatePicker
            label="Desde"
            placeholder="Desde"
            onChange={(v: string) => this.change(v, 'from')}
            value={form.from}
          />
          <DatePicker
            label="Hasta"
            placeholder="Hasta"
            onChange={(v: string) => this.change(v, 'to')}
            value={form.to}
          />
          {canCleanFilters && (
            <Button clear onClick={this.cleanFilters}>
              Limpiar
            </Button>
          )}
        </section>

        <div className="rg-table">
          <div className="rg-table-header">
            <p>Consultas</p>
            <div className="rg-table-actions">
              <button onClick={this.download}>
                <img src={Download2Icon} alt="Descargar" />
                <span>Descargar Excel</span>
              </button>
            </div>
          </div>
          <table>
            <thead>
              <tr>
                <th>Fecha de la cita</th>
                <th>Paciente</th>
                <th>C.I</th>
                <th>Modalidad</th>
                <th>Médico</th>
                <th>Especialidad</th>
                <th>
                  Precio de consulta ($)
                </th>
                <th>Método de pago</th>
                <th>Precio en Bs</th>
                <th>Estatus</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {this.state.data.map((appoiment: any, index: number) => {
                const status = getStatusColor(appoiment?.status);
                return (
                  <tr key={`patient-${index}`}>
                    <td>{moment(appoiment?.date).format('DD-MM-YYYY')}</td>
                    <td>{appoiment?.user?.full_name}</td>
                    <td>{appoiment?.user?.document}</td>
                    <td>{appoiment?.type?.name}</td>
                    <td>{appoiment?.doctor?.full_name}</td>
                    <td>{appoiment?.service?.specialty?.name}</td>
                    <td className='bold price'>{Globals.formatMiles(appoiment?.service?.price)}</td>
                    <td>{appoiment?.payment?.payment_method?.name}</td>
                    <td>
                      {!appoiment?.plan_id && (
                        <span>
                          {Globals.formatMiles(appoiment?.payment?.amount_local, true, 'Bs')}
                        </span>
                      )}
                    </td>
                    <td className={status?.className}>{status?.label}</td>
                    <td>
                      <div className='actions'>
                        <img
                          src={ViewIcon}
                          alt="Editar"
                          title="Editar"
                          onClick={() => this.setModal(MODAL.VIEW, appoiment)}
                        />
                      </div>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>

          {!this.state.data.length && (
            <div className='no-items'>
              <p>No se encontraron resultados</p>
            </div>
          )}
        </div>

        <Pagination
          pages={this.state.pagination.pages}
          active={this.state.pagination.page}
          onChange={this.load}
        />
      </div>
    )
  }

}
export default Appointments;